import { createRouter, createWebHistory } from 'vue-router';
import Home from '@/views/HomeInicio.vue'; // Asegúrate de que este archivo exista

import NuevoHola from '../views/NuevoHola.vue'
import SamTarea from '../views/SamTarea.vue'; // Asegúrate de que este archivo exista
import listaTareas from '../components/ListaTareas.vue'; // Asegúrate de que este archivo exista

const routes = [
    { path: '/', component: Home },
    { path: '/jesus', component: NuevoHola},
    { path: '/sam', component: SamTarea},
    { path: '/IrvinAdmin', component: listaTareas}
];

const router = createRouter({
    history: createWebHistory(),
    routes
});

export default router;
